export default __webpack_public_path__ + "static/media/vilecorruption.e6f28edb.png";